/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import cn from "clsx";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { ReactComponent as ChevronLeft } from "cms/assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRight } from "cms/assets/icons/chevron-right.svg";

const HeroSlide = (props) => {

    const { slides, images, index, total, moveIndex } = props || {};

    const slide = slides[index];
    const image = Array.isArray(images) && images[index];
    const { src, alt } = image || {};

    const { title, subtitle = "", description, link } = slide || {};
    const { text, url: link_url } = link || {};

    const showControls = slides.length > 1;
    const controlsClassName = cn("forward-back", { "hide": !showControls });

    const goToPreviousSlide = () => {
        moveIndex(-1);
    };
    const goToNextSlide = () => {
        moveIndex(1);
    };

    return (
        <div
            className='hero-slide'
            title={alt}
            style={{
                backgroundImage: `url(${src})`
            }}
        >
            <div className='hero-content-container'>
                <div className='hero-content'>

                    <h1>
                        {title}
                        {subtitle && <span>{` ${subtitle}`}</span>}
                    </h1>

                    <RichTextSimple
                        richtext={description}
                        className='hero-slide-description'
                    />
                    <Link to={link_url} className='hero-slide-link'>
                        {text}
                    </Link>
                </div>

                <div className='hero-controls'>

                    <div className={controlsClassName}>

                        <button aria-label='Previous' onClick={goToPreviousSlide}>
                            <ChevronLeft />
                        </button>

                        <span>{`${index + 1}/${total}`}</span>

                        <button aria-label='Next' onClick={goToNextSlide}>
                            <ChevronRight />
                        </button>

                    </div>
                </div>
            </div>

        </div>
    );
};
export { HeroSlide };
